import React, { FC, useState } from 'react';
import classnames from 'classnames';
import Preview from '@src/components/Preview';
import { BannerOnCreateOpeningPage } from '@src/containers/PremiumServiceBanners';
import Details from './Details';
import { ActiveTab } from './enums/activeTab.enum';
import { SidebarProps } from './props';
import './styles.scss';

export const Sidebar: FC<SidebarProps> = ({
  benefits,
  companyProfile,
  defaultTab = ActiveTab.STATS,
  isTabsDisabled,
  onTabSwitch,
  opening,
  previewUrl,
  question,
  isSaving,
  recruiter,
}) => {
  const [activeTab, setActiveTab] = useState<ActiveTab>(defaultTab);

  const switchTab = (activeTab: ActiveTab) => {
    setActiveTab(activeTab);

    if (onTabSwitch) {
      onTabSwitch(activeTab);
    }
  };

  const isPreviewShown = !!companyProfile?.isComplete;

  const isStatsActive = activeTab === ActiveTab.STATS || !isPreviewShown;

  return (
    <div className="sidebar-wrapper">
      <div className={classnames('sidebar sticky', isStatsActive && 'stats')}>
        {!isTabsDisabled && (
          <div className="sidebar-tabs">
            <div
              className={classnames('sidebar-tabs-item', isStatsActive && 'active')}
              onClick={() => switchTab(ActiveTab.STATS)}
            >
              Targeting
            </div>

            {isPreviewShown && (
              <div
                className={classnames('sidebar-tabs-item', !isStatsActive && 'active')}
                onClick={() => switchTab(ActiveTab.PREVIEW)}
              >
                Preview
              </div>
            )}
          </div>
        )}

        {isStatsActive && <Details opening={opening} saving={!!isSaving} />}

        {!isStatsActive && (
          <Preview
            benefits={benefits}
            companyProfile={companyProfile}
            opening={opening}
            question={question}
            recruiter={recruiter}
            url={previewUrl}
          />
        )}

        {isStatsActive && <BannerOnCreateOpeningPage />}
      </div>
    </div>
  );
};
